exports.shorter = function shorter() {return elementorySupport.getJSON(generateWebMethodUrl("shorter","backend/short.jsw"), arguments, undefined, undefined)}